import { useState } from 'react'

import { Tooltip } from 'antd'
import moment from 'moment'
import { isArray, isFunction } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { EUROPEAN_DATE, EUROPEAN_DATE_WITH_HOURS_AND_MINUTES, HOURS_AND_MINUTES } from '../../../utils/constants'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import ChatMessageFile from './ChatMessageFile'

const ChatMessage = ({ files, message, timestamp, received, username, pinned, onPin }) => {
  const t = useSelector(selectTranslate)

  const [isHovered, setIsHovered] = useState(false)

  const now = moment()
  const time = moment(timestamp)

  const displayedTime = time.isSameOrAfter(now, 'day') ? time.format(HOURS_AND_MINUTES) : time.format(EUROPEAN_DATE)

  const showPinButton = isFunction(onPin) && (pinned || isHovered)

  return (
    <div
      className={'message ' + (received ? 'received' : 'sent')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tooltip title={time.format(EUROPEAN_DATE_WITH_HOURS_AND_MINUTES)} placement='right'>
        <div className='text-bubble'>
          <div className='user-and-time'> <b>{username}</b> - {displayedTime}</div>
          <div className='text'>{message}</div>
          {showPinButton && (
            <Tooltip title={t(pinned ? 'chat_message.unpin' : 'chat_message.pin')} placement='top'>
              <FontAwesomeIcon
                icon={faThumbtack}
                className={'pin-button' + (pinned ? ' pinned' : '')}
                onClick={onPin}
              />
            </Tooltip>
          )}
        </div>
      </Tooltip>
      {isArray(files) && files.map(file => (
        <ChatMessageFile key={file.id} file={file} received={received} />
      ))}
    </div>
  )
}

export default ChatMessage
